import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Link } from '@mui/material';


function HeaderAlter() {

  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  return (
    <>
      <AppBar position="static" sx={{ bgcolor: '#ffffff' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img 
              src="https://nexotur.com/wp-content/uploads/imagenes_web_antigua/fotos/1/Logo_CamaraMadrid_RGB.jpg" 
              alt="Logo Cámara Madrid" 
              style={{ height: 50 }}
            />
          </Box>

          

        </Toolbar>
      </AppBar>


   <AppBar 
        position="static" 
        sx={{ 
          background: 'linear-gradient(to right, #ff5a4b, #920000)', 
          boxShadow: 'none', 
          py: 1 
        }}
      >
        <Toolbar sx={{ justifyContent: 'center' }}>
          <Typography variant="h5" sx={{ color: 'white', fontWeight: 'bold' }}>
            Cámara Oficial de Comercio, Industria y Servicios de Madrid
          </Typography>
        </Toolbar>
      </AppBar>

    
    </>
  );
}

export default HeaderAlter;